import React from 'react';
import { Box, Stack } from '@mui/material';
import { AssessmentGrid, type RowData } from '../../../../components';
import { PAGE_TEXT } from '../../../../lang';
import type { DrcDrading } from '../../../../graphql';

type ScoresOnApplicantBoxProps = {
  initialValues: DrcDrading;
  isViewMode: boolean;
  onJumpToNext: () => void;
};

export const ScoresOnApplicantBox: React.FunctionComponent<
  ScoresOnApplicantBoxProps
> = props => {
  const { initialValues, isViewMode, onJumpToNext } = props;
  const { DRC_ASSESSMENT_DETAILS } = PAGE_TEXT;
  const STEP_TEXT = DRC_ASSESSMENT_DETAILS.ASSESSMENT.STEP_F;
  const NA = 'NA';
  const scoresRowData: RowData[] = [
    {
      label: STEP_TEXT.FIRST_DEGREE_UNIVERSITY_RANKING,
      value: initialValues.firstDegreeUniversityRanking ?? NA,
    },
    {
      label: STEP_TEXT.FIRST_DEGREE_GPA_RANKING,
      value: initialValues.firstDegreeGPAOrClassRanking ?? NA,
    },
    {
      label: STEP_TEXT.PUBLICATION_MERIT,
      value: initialValues.publicationAndMerit ?? NA,
    },
    {
      label: <strong>{STEP_TEXT.TOTAL}</strong>,
      value: initialValues.total ?? NA,
    },
  ];

  return (
    <div>
      <Stack margin={4}>
        <Box marginRight={4} marginLeft={4}>
          <AssessmentGrid rows={scoresRowData} needHr={true} />
          <div className="w-full flex !mt-24 !mb-8 justify-center">
            {!isViewMode && (
              <h2
                className="cursor-pointer underline decoration-1 text-[#951d1d]"
                onClick={onJumpToNext}
              >
                {PAGE_TEXT.MOVE_NEXT}
              </h2>
            )}
          </div>
        </Box>
      </Stack>
    </div>
  );
};
